export default __webpack_public_path__ + "static/media/avatar-s-8.e9b18971.jpg";